import React from 'react';

import autoBind from 'react-autobind';

// import other components within the same project here
import Config from '../Config.jsx';
import request from 'superagent';

class LoginCreateSession extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();
    // state variables here
    this.state = {
    };
    autoBind(this);

    if(this.props.username != null && this.props.username.length > 0 &&
      this.props.password != null && this.props.password.length > 0){
        this.sendLoginRequest(this.props.username, this.props.password, this.props.loginOKFunction, this.props.loginFailFunction);
      }
  }

  sendLoginRequest(username, password, loginOKCallback, loginFailedCallback){
    // console.log("LoginCreateSession");
    // console.log(username);
    // console.log(password);
    request
      .post(Config.API_PATH() + "do_login_json.php")
      .send({ username: username,
              password: password})
      .set('Content-Type', 'application/x-www-form-urlencoded')
      .end( (err, res) => {
          // Calling the end function will send the request\

        if (err || !res.body.login_result > 0 ) {
          //  alert('Oh no! error');
          loginFailedCallback(err);
        } else {
          loginOKCallback(res);
        }
      });


  }

  render() {
      return (
        <div>

        </div>
      )
  }

}

export default LoginCreateSession;
